import { AloftPrice } from '@aloft/toolkit-shared';

import { applyRoundingAndThresholds } from '../../../redux/features/selectors/adjustmentSelectors/utils/applyRoundingAndThresholds.ts';
import { selectAdjustmentSettings } from '../../../redux/features/selectors/orderSelectors.ts';

// We need to respect rounding settings here (see TKE-1369).
export const getDateOfSaleOrListToSaleAdjustmentDisplay = (
  dateOfSaleOrListToSaleAdjustment: AloftPrice,
  settings: ReturnType<typeof selectAdjustmentSettings>,
): string => {
  const applied =
    applyRoundingAndThresholds(dateOfSaleOrListToSaleAdjustment, 'dateOfSale', settings) ??
    AloftPrice.zero;
  return applied.toString(true);
};
